export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";